import { JackpotTiers } from "ags/names";
import { GameiomConfigSchema } from "gameiom/schema/gameiom-config-schema";
import { GameiomPlatformSchema } from "gameiom/schema/gameiom-platform-schema";

export interface AGSSpinResponseSchema {
    publicState: AGSSpinPublicStateSchema;
    platform: GameiomPlatformSchema;
    config: GameiomConfigSchema;
}

export interface AGSSpinPublicStateSchema {
    action: string;
    betAmount: number;
    denom: number;
    spin: AGSSpinSchema;
}

export interface AGSSpinSchema {
    type: string;
    totalSpinWin: number;
    reels: number[][];
    wins: AGSWin[];
    sumWins: number;
    childFeature: AGSSpinSchema[] | AGSPickSchema[];
    MCSymbols?: HoldAndSpinSymbolSchema[];
    complete: boolean;
    events: AGSEvent[];
    freeSpinsLeft: number;
    totalFreeSpins: number;
    sumWinsFreeSpins: number;
}

export interface AGSPickSchema {
    type: string;
    index: number;
    value: string;
    complete: boolean;
    cashWon: number;
}

export interface AGSWin {
    evaluationType: string;
    winAmount: number;
    winningSymbolsPositions: number[][];

    lineNumber: number;
    symbolId: number;
    multiplier: number;
    ways: number;
    freeSpinsAmount: number;
    featureType: string;
    bonusType?: number;
}

export interface AGSFeature {
    tbc: string;
}

export interface AGSEvent {
    id: string;
    positions?: number[][];
    upgrade?: boolean;
    state?: number;
    gender?: string;
}

export enum AGSWinTypes {
    POWER_X_STREAM = "PowerXStream",
    SCATTER = "Scatter",
    LINE = "line",
    RANDOM = "random",
    FREESPIN = "freeSpin"
}

export interface HoldAndSpinSymbolSchema {
    coordinate: number[];
    Index: number;
    JPSymbolIfString?: JackpotTiers;
    symbol: number;
    winAmount: number;
}

export interface HoldAndSpinSchema extends AGSPickSchema {
    MCSymbols: HoldAndSpinSymbolSchema[];
    freeSpinsLeft: number;
    freeSpinsspun: number;
    BonusNumber: number;
}

export enum AGSFeatureTypes {
    FREESPINS_WIN = "freeSpinWin",
    PICK = "Pick"
}
